.tabs {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.list {
  display: flex;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
  border-bottom: 1px solid var(--color-border);
  overflow-x: auto;
  scrollbar-width: none;
}

.list::-webkit-scrollbar {
  display: none;
}

.navItem {
  display: flex;
}

.tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2-5) var(--space-3);
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  text-decoration: none;
  transition: color var(--duration-fast) var(--ease-out);
}

.tab::after {
  content: '';
  position: absolute;
  left: var(--space-2);
  right: var(--space-2);
  bottom: -1px;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background-color: transparent;
  transition: background-color var(--duration-fast) var(--ease-out);
}

.tab:hover:not([aria-disabled='true']) {
  color: var(--color-text);
}

.tab:hover:not([aria-disabled='true'])::after {
  background-color: var(--color-border-strong);
}

.tab:focus-visible {
  outline-offset: -2px;
}

.tab[aria-disabled='true'] {
  color: var(--color-text-disabled);
  cursor: not-allowed;
}

.active,
.active:hover {
  color: var(--color-link);
  font-weight: var(--font-weight-semibold);
}

.active::after,
.active:hover:not([aria-disabled='true'])::after {
  background-color: var(--color-primary);
}

.badge {
  display: inline-flex;
  align-items: center;
  min-width: 1.25rem;
  padding: 0 var(--space-1-5);
  border-radius: var(--radius-full);
  background-color: var(--color-neutral-bg);
  color: var(--color-neutral-fg);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  line-height: 1.25rem;
  justify-content: center;
  font-variant-numeric: tabular-nums;
}

.active .badge {
  background-color: var(--color-primary-subtle);
  color: var(--color-link);
}

.invalid,
.invalid:hover {
  color: var(--color-danger-fg);
}

.errorDot {
  width: 0.5rem;
  height: 0.5rem;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  background-color: var(--color-danger);
}

.panel {
  padding-top: var(--space-4);
}

.panelStack {
  display: grid;
}

.panelStack > .panel {
  grid-area: 1 / 1;
  min-width: 0;
}

.panel:focus-visible {
  outline-offset: 4px;
  border-radius: var(--radius-sm);
}
